import mixpanelBrowser from 'mixpanel-browser';

const token = process.env.REACT_APP_MIXPANEL_TOKEN;

// Admin dashboard is internal-only — never tracked, never session-recorded.
const isAdminUI = () =>
  typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');

// record_sessions_percent: 100 — room photos/videos stay blocked (record_block_selector
// default "img, video"), text/inputs stay masked (record_mask_all_text/inputs default true).
let initialized = false;
if (token && !isAdminUI()) {
  mixpanelBrowser.init(token, {
    track_pageview:         false,
    persistence:            'localStorage',
    record_sessions_percent: 100,
  });
  initialized = true;
}

export const mixpanel = {
  track: (event: string, properties?: Record<string, unknown>) => {
    if (initialized && !isAdminUI()) mixpanelBrowser.track(event, properties);
  },
  identify: (id: string) => { if (initialized && !isAdminUI()) mixpanelBrowser.identify(id); },
  reset: () => { if (initialized) mixpanelBrowser.reset(); },
  // Called when the SPA navigates into /admin so session replay stops mid-session.
  stopSessionRecording: () => {
    if (initialized) {
      try { (mixpanelBrowser as any).stop_session_recording?.(); } catch { /* replay not active */ }
    }
  },
};
